import axios from 'axios';
import { BASE_URL } from '../misc/Static_routes';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

export default axiosInstance;